/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Supplyairtemperaturedefect3Inputs */



/**
* | output |
* | --- |
* | "Supply air temperature sensor fault" |
*
* @param {Ahu_History_Key_Supplyairtemperaturedefect3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_supplyairtemperaturedefect3 = /** @type {((inputs?: Ahu_History_Key_Supplyairtemperaturedefect3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Supplyairtemperaturedefect3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Supply air temperature sensor fault")
	return /** @type {LocalizedString} */ ("Défaut sonde température air soufflé")
});
export { ahu_history_key_supplyairtemperaturedefect3 as "ahu_history_key_supplyAirTemperatureDefect" }